import { Transition } from 'react-transition-group';
import Button from '../../../components/button';
import { AlertPopupContainer } from '../../../components/alert-popup/alertPopup.styled';
import Heading from '../../../components/typography';

interface ConfirmationModalType {
  isModalOpen: boolean;
  confirmLoading: boolean;
  closeConfirmModal: () => void;
  handleConfirmClick: () => void;
  domId?: string;
}

const ConfirmationModal = ({
  isModalOpen,
  confirmLoading,
  closeConfirmModal,
  handleConfirmClick,
  domId,
}: ConfirmationModalType): JSX.Element => {
  return (
    <Transition in={isModalOpen} timeout={250}>
      {(state) => (
        <AlertPopupContainer id={domId}>
          <div className={`modalBackdrop modalBackdrop-${state}`} id='modalBackdrop'>
            <div className={`sideBar sideBar-${state} `} id='modalContainer'>
              <div className='popupDialog' id='popupDialog'>
                <div className='popupContent' id='popupContent'>
                  <Heading
                    variant='h5'
                    className='mb-5'
                    title='Are you sure you want to use delete this bank account?'
                    id='confirmationMessage'
                  />
                  <div className='popupButtons' id='buttonContainer'>
                    <Button
                      variant='primary-dark'
                      type='button'
                      title='No'
                      onClick={() => {
                        closeConfirmModal();
                      }}
                      id='cancelButton'
                    />
                    <Button
                      variant='primary'
                      title='Confirm'
                      as='Delete'
                      onClick={() => {
                        handleConfirmClick();
                      }}
                      icon={<span className='material-symbols-outlined'>check_circle</span>}
                      loading={confirmLoading}
                      id='confirmButton'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AlertPopupContainer>
      )}
    </Transition>
  );
};

export default ConfirmationModal;
